import { createFeatureFlagsContext } from "@packages/feature-flags";
import defaultFlags from "./defaultFlags.json";

export type FlagKey = keyof typeof defaultFlags;

const {
  Provider: FeatureFlagsProvider,
  useFeatureFlags,
  useExperienceString,
} = createFeatureFlagsContext<FlagKey>();

export { FeatureFlagsProvider, useFeatureFlags, useExperienceString };
